import _ from 'lodash';
import React from 'react';
import { useQuery } from 'react-fetching-library';

/**
 * Hook that fetches data from given action function
 * @param {Function} action action fetching library function
 * @returns {[{Promise, Object}, {Object, Object}]} query Promise for re-fetching data and data object if action function is valid
 */
export default action => {
  const [data, setData] = React.useState({});
  if (action) {
    const { loading, payload, error, query } = useQuery(action);

    React.useEffect(() => {
      if (!error && !loading && !_.isNil(action)) {
        setData(payload);
      }
    }, [loading]);

    return { query, data, loading };
  }
  const { loading } = false;

  return { data, data, loading };
};
